import { estLivraisonBloquee } from './actions.js';
import { formatCourt, joursEntre } from './dates.js';
/**
 * Les colis que la relance réclame.
 *
 * Les colis BLOQUÉS s'il y en a — c'est ce que la relance signale. Sinon (un
 * retard, un silence), tous ceux qui ne sont pas encore livrés. Le premier
 * colis en fait partie tant qu'il n'est pas livré, et vient en tête.
 */
export function colisARelancer(c) {
    const enRoute = [];
    if (c.tracking?.trim() && !c.livre && !c.premierColisLivre) {
        enRoute.push({
            tracking: c.tracking.trim(), transporteur: c.transporteur,
            statut: c.statutTransporteur, jour: c.dateStatutTransporteur,
        });
    }
    for (const k of c.colis) {
        if (k.livre)
            continue;
        enRoute.push({
            tracking: k.tracking, transporteur: k.transporteur,
            statut: k.statutTransporteur, jour: k.dateStatutTransporteur,
        });
    }
    const bloques = enRoute.filter((k) => estLivraisonBloquee(k.statut));
    return bloques.length ? bloques : enRoute;
}
/** Une ligne par colis : numéro, transporteur, dernier statut et sa date. */
export function listeColisRelance(colis) {
    return colis.map((k) => `- ${k.tracking}${k.transporteur ? ` (${k.transporteur})` : ''} : `
        + `${k.statut || 'aucun point de suivi'}${k.jour ? `, le ${formatCourt(k.jour)}` : ''}`).join('\n');
}
/**
 * Remplit le modèle de relance transporteur de Réglages.
 *
 * **Un seul colis concerné** : le texte d'avant, mais sur CE colis — qui n'est
 * pas forcément le premier, quand c'est un colis supplémentaire qui bloque.
 *
 * **Plusieurs** : `{{tracking}}` les énumère, `{{transporteur}}` nomme chacun
 * des transporteurs, et `{{statut}}` devient la liste détaillée, un colis par
 * ligne. Les modèles déjà enregistrés fonctionnent ainsi sans retouche.
 * `{{colis}}` donne la même liste, pour un modèle qui veut la placer lui-même.
 */
export function remplirRelanceTransporteur(modele, c, livraisonEstimee, aujourdhui) {
    const concernes = colisARelancer(c);
    const liste = listeColisRelance(concernes);
    const plusieurs = concernes.length > 1;
    const seul = concernes[0];
    const transporteurs = [...new Set(concernes.map((k) => k.transporteur).filter((t) => Boolean(t)))];
    const retard = livraisonEstimee ? Math.max(0, joursEntre(livraisonEstimee, aujourdhui)) : null;
    const valeurs = {
        '{{ref}}': c.ref,
        '{{client}}': c.client,
        '{{ville}}': c.ville ?? '—',
        '{{transporteur}}': (plusieurs ? transporteurs.join(' et ') : seul?.transporteur ?? c.transporteur) || '—',
        '{{tracking}}': plusieurs ? concernes.map((k) => k.tracking).join(', ') : (seul?.tracking ?? c.tracking ?? '—'),
        '{{expedition}}': formatCourt(c.dateExpedition),
        '{{prevue}}': livraisonEstimee ? formatCourt(livraisonEstimee) : '—',
        '{{retard}}': retard === null ? '—' : String(retard),
        '{{statut}}': plusieurs
            ? `\n${liste}`
            : (seul ? seul.statut : c.statutTransporteur) || 'aucun point de suivi',
        '{{colis}}': liste,
    };
    const remplir = (t) => Object.entries(valeurs)
        .reduce((acc, [cle, v]) => acc.split(cle).join(v), t)
        // « Dernier statut remonté : » suivi de la liste laisse une espace en fin de ligne.
        .replace(/[ \t]+\n/g, '\n');
    // Un objet tient sur une ligne : la liste s'y aplatit.
    const objet = remplir(modele.objet).replace(/\s*\n-?\s*/g, ' · ').trim();
    return { objet, corps: remplir(modele.corps), colis: concernes };
}
//# sourceMappingURL=relance-transporteur.js.map